import { z } from 'zod';
import { ReactionSummarySchema } from './reactions.js';
// ─── Упоминания в комментарии ───────────────────────────────────────────────
//
// Упомянуть можно человека (`@login`), группу пользователей пространства
// (`@Команда_Android`) или всех участников (`@все`). В тексте комментария
// остаётся токен, а этот список говорит серверу, кого уведомить.
//
// Группу и «всех» сервер разворачивает в получателей сам, в момент отправки:
// клиент не присылает готовый список людей, поэтому подделать адресатов или
// разослать уведомление постороннему через выдуманный `userId` нельзя.
//
// У упоминания человека `kind` может отсутствовать — так выглядят записи,
// созданные до появления групп; читаем их как `user`.
export const CommentMentionSchema = z.union([
    z.object({
        kind: z.literal('user').optional(),
        userId: z.string().uuid(),
        displayName: z.string(),
    }),
    z.object({
        kind: z.literal('group'),
        groupId: z.string().uuid(),
        displayName: z.string(),
    }),
    z.object({
        kind: z.literal('all'),
        displayName: z.string(),
    }),
]);
/** Токен «все участники» в тексте комментария. */
export const MENTION_ALL_TOKEN = 'все';
// ─── Request schemas ────────────────────────────────────────────────────────
export const CreateCommentRequestSchema = z.object({
    body: z.string().min(1, 'Комментарий не может быть пустым').max(10000),
    mentions: z.array(CommentMentionSchema).optional().default([]),
    /** Ответ на этот комментарий. Ответ на ответ сервер прицепит к первому комментарию ветки. */
    parentId: z.string().uuid().optional(),
});
export const UpdateCommentRequestSchema = z.object({
    body: z.string().min(1, 'Комментарий не может быть пустым').max(10000),
    mentions: z.array(CommentMentionSchema).optional(),
});
// ─── Response schemas ───────────────────────────────────────────────────────
export const CommentAuthorSchema = z.object({
    id: z.string().uuid(),
    login: z.string(),
    displayName: z.string(),
});
export const CommentSchema = z.object({
    id: z.string().uuid(),
    itemId: z.string().uuid().nullable(),
    spaceId: z.string().uuid(),
    authorId: z.string().uuid(),
    /** Первый комментарий ветки, если это ответ; null — комментарий верхнего уровня. */
    parentId: z.string().uuid().nullable().default(null),
    body: z.string(),
    mentions: z.array(CommentMentionSchema),
    author: CommentAuthorSchema,
    reactions: z.array(ReactionSummarySchema).default([]),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const CommentListResponseSchema = z.object({
    comments: z.array(CommentSchema),
});
